<template>
    <div class="has-background-pale-grey lb-full-height is-clipped">
        <section
            class="has-scroll-y is-scroll-hidden"
            style="padding: 2em; height: 100%"
        >
            <div class="container">
                <div class="columns is-centered">
                    <div class="column is-10-tablet is-12-desktop">
                        <div class="step-content has-text-centered">
                            <creation-options
                                class="pb-6"
                                @click="loadCreationTemplate"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import CreationOptions from '@/components/CreationOptions';
import CreationConfiguration from '@/components/CreationConfiguration';
import { createItem } from '@/services/API';

import _ from 'underscore';
export default {
    components: { CreationOptions, CreationConfiguration },
    data() {
        return {
            type: null,
            isConfigured: false,
            creating: false,
        };
    },
    computed: {
        typeSelected() {
            return !!this.configuration.type;
        },
    },
    methods: {
        loadCreationTemplate: _.throttle(async function (type) {
            if (this.creating) {
                return;
            }

            let currentLocale = this.$i18n.locale;
            if (currentLocale == 'ca-ES') {
                currentLocale = 'ca';
            }

            let adjective = _.sample(
                this.$store.state[
                    'CREATION_ADJECTIVES_' +
                        type.type.toUpperCase() +
                        '_' +
                        currentLocale.toUpperCase()
                ],
                1
            );

            // let verb = _.sample(this.$store.state.CREATION_VERBS, 1);
            let verb = _.sample(
                this.$store.state[
                    'CREATION_VERBS_' + currentLocale.toUpperCase()
                ],
                1
            );

            this.creating = true;
            this.$Progress.start();
            let response = this.$store
                .dispatch('createProject', {
                    type: type.type,
                    title: `${this.$t(
                        type.name + '_creation_title_auto'
                    )} ${adjective}`,
                    description: `${this.$t(
                        'creation_description_auto'
                    )} ${verb}`,
                    mode: type.mode,
                    folder: this.$route.query.folder,
                })
                .then((response) => {
                    this.$router.push({
                        name: 'project',
                        params: { projectId: response.data._id },
                    });
                })
                .catch((e) => {
                    console.log('catch', e);
                    this.$Progress.fail();
                })
                .finally(() => {
                    this.creating = false;
                });
        }, 750),
    },
};
</script>
